"use client";

import { useEffect } from "react";
import { useAuth } from "../providers/AuthProvider";
import { connectWebSocket, disconnectWebSocket } from "../lib/websocket";

/**
 * Lightweight component that connects/disconnects the WebSocket based on auth state.
 * Replaces WebSocketProvider — no context, no children wrapping.
 */
export function WebSocketInit() {
  const { token } = useAuth();

  useEffect(() => {
    if (token) {
      connectWebSocket(token);
    } else {
      disconnectWebSocket();
    }
    return () => disconnectWebSocket();
  }, [token]);

  return null;
}
